<template>
    <Layout>
        <!-- <section class="section">
            <div class="container">
                <h2>Confirmed Companies</h2>
                <p>
                    The list of attending companies will be made available soon.
                </p>
                <table id="companies-table">
                    <thead>
                        <tr>
                            <th>
                                Company
                            </th>
                            <th>
                                Country
                            </th>
                            <th>
                                RIC
                            </th>
                            <th>
                                Bloomberg
                            </th>
                            <th>
                                Sector
                            </th>
                            <th>
                                Presentation
                            </th>
                            <th>
                                Research
                            </th>
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>

            <section class="section section-sm">
                <div class="container">
                    <div class="text-center">
                        <a class="download-companies-list btn" href="downloads/presenters-list.xlsx">Download Company List</a>
                    </div>
                </div>
		    </section>

        </section> -->

        <section class="section section_style">
      <h2>Confirmed Companies</h2>

      <table id="myTable" class="display">
        <thead>
          <tr v-if="companies">
            <th>Company</th>
            <th>Country</th>
            <th>Sector</th>
            <th>Bloomberg</th>
            <th>Reuter</th>
            <th>Presentations</th>
            <th>Research Report</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(company,index) in companies" v-bind:key="index">
            <td v-if="company.website" > <a class="toolTip-wrapper" style="position:relative" :href="company.website" target="_blank" > {{ company.name }} <span class="toolTip" >Website: {{ company.website }}</span> </a> </td>
            <td v-if="!company.website"> <a href="#" > {{ company.name }} </a> </td>
            <td>{{ company.country.name}}</td>
            <td>{{ company.sector.name}}</td>
            <td> {{ company.bloomberg }} </td>
            <td> {{ company.reuter }} </td>

            <td class="presntation-font">
                <div>
                    <div class="_put-cursor" v-if="company.uploads.length > 0" v-for="upload in company.uploads">
                        <span v-on:click="downloadFile(company.id , upload.id , 'presentation' )" v-if="upload.presentation" > Download Presentation </span>
                    </div>
                    <span style="font-weight:normal"  v-if=" companyHasNoPresentation(company.uploads)  && noPresentationCompanies.includes(company.name)" > No Presentation Provided </span>
                </div>
            </td>

            <td class="presntation-font">
                <div>
                    <div class="_put-cursor" v-if="company.uploads.length > 0" v-for="upload in company.uploads">
                        <span v-if="upload.profile" v-on:click="downloadFile(company.id , upload.id , 'profile' )" > Download Report </span>
                    </div>
                </div>
            </td>
          </tr>
        </tbody>
      </table>

      <section class="section section-sm">
        <div class="container">
          <div class="text-center">
            <!-- <a
                href="https://files.efghermes.com/UserFiles/Conferences/88/downloads/CompaniesList2021.xlsx"
              class="download-companies-list btn"
            >Download Company List</a> -->
            <!-- <a
                href="https://files.efghermes.com/UserFiles/Conferences/88/downloads/CompaniesVal2021.xlsx"
              class="download-companies-list btn"
            >Download Company Valuation Table</a> -->
          </div>
        </div>
      </section>
    </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Api from "@/Api";
import $ from "jquery";
import axios from "axios";
import JSZip from "jszip";
window.JSZip = JSZip; // required to make Buttons extension work for Excel button

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-se";
import "datatables.net-buttons-se";

export default {
    name: "AuthedCompanies",
    components: { Layout },

    data() {
        return {
            companies: [],
            noPresentationCompanies:['Al Rajhi Bank' , 'Saudi British Bank (SABB)' , 'ARAMCO' , 'Al Hammadi' , 
                                     'Saudi Ground Services Co.' , 'Middle East Paper Co.', 'City Cement Company', 'Taiba Investments',
                                     'Saudi Company for Hardware - SACO', 'Middle East Paper Co.' , 'Al Moammar Information Systems',
                                     'Zain KSA', 'Aldrees'
                                    ]
            // noPresentationCompanies : [
            //     'Qalaa Holdings' , 'Housing and Development Bank' , 
            //     'Bindawood', 'ZAIN KSA' , 'Aramex' , 'TMG Holding' , 'Aldar Properties', 'Mabanee Company',
            //     'Saudi Company for Hardware | SACO' , 'Kuwait International Bank' ,'Tawuniya',
            //     'Bindawood', 'Credit Agricole Egypt', 'Saudi Ceramics', 'Zain KSA'
            // ]
        };
    },

    methods: {
        getPageData() {
            Api()
                .get("general/registerd-companies")
                .then(res => {
                    this.companies = res.data.companies;
                })
                .catch(error => console.log("error", error));
        },
        automaticDownloadAfterLogin() {
            let logged = this.$store.getters.isLoggedIn;
            let downloadUri = localStorage.getItem("beforeLoginChoice");
            if (logged && downloadUri) {
                let client = JSON.parse(localStorage.getItem("client"));
                if (downloadUri.toString() === "all") {
                    $("#myTable_wrapper .dt-buttons .buttons-excel").click();
                } else {
                    if (client.client.client_type.type === 1) {
                        window.location =
                            process.env.VUE_APP_API_URL + downloadUri;
                    }
                }
            }
            localStorage.removeItem("beforeLoginChoice");
        },
        downloadCompaniesList() {
            let logged = this.$store.getters.isLoggedIn;
            if (!logged) {
                localStorage.setItem("redirect", "/companies");
                localStorage.setItem("beforeLoginChoice", "all");
                this.$router.push({
                    name: "login"
                });
            } else {
                $("#myTable_wrapper .dt-buttons .buttons-excel").click();
            }
        },
        downloadFile: function(companyId, recordId, type) {
            let conferenceId = process.env.VUE_APP_CONFERENCE_ID;
            let logged = this.$store.getters.isLoggedIn;
            if (!logged) {
                let downloadUrl = `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}&record_id=${recordId}`;
                localStorage.setItem("redirect", "/companies");
                localStorage.setItem("beforeLoginChoice", downloadUrl);
                this.$router.push({
                    name: "login"
                });
            } else {
                let client = JSON.parse(localStorage.getItem("client"));
                if (client.client.client_type.type === 1) {
                    let url =
                        process.env.VUE_APP_API_URL +
                        `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}&record_id=${recordId}`;
                    window.open(url , '_blank');
                } else {
                    return alert("Sorry you don't have permission");
                }
            }
        },
        companyHasNoPresentation(companyUploads) {
            const uploads = companyUploads.filter(upload => upload.presentation !== null);
            return !uploads.length;
        }
    },
    beforeMount(){
        let client = JSON.parse(localStorage.getItem("client"));
        if( !client || !(client.client.client_type.type === 1) )
        {
            window.location = '/';
        }
    },
    mounted() {
        this.getPageData();
        this.automaticDownloadAfterLogin();
    },
    updated() {
        $("#myTable").DataTable({
            dom: "Bfrtip",
            "pageLength": 100,
            buttons: [
                {
                    extend: "excelHtml5",
                    exportOptions: {
                        columns: [0, 1, 2]
                    }
                }
            ]
        });
        $("#myTable_wrapper .dt-buttons .buttons-excel").hide();
    }
};
</script>

<style>
.section_style {
    padding: 30px 64px;
}

.presntation-font {
    color: #004631;
    font-weight: bold;
}

._put-cursor {
    cursor: pointer;
}

/* DATA TABLE STYLES */
.dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
    background: none;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
    background: none;
    color: #a2ad1c !important;
    border: 1px solid #a2ad1c;
}

.toolTip {
    position: absolute;
    bottom: 20px;
    left: 0;
    display: none;
    background-color: yellow;
    width: 300px;
    background-color: black;
    color: white;
    font-size: 0.8rem;
    text-align: center;
    border-radius: 4px;
}

.toolTip-wrapper:hover .toolTip {
    display: block;
}

</style>
